import { buildAffiliateParams } from "~/utils/_helpers";

export const getters = {
  getCartId(state) {
    return state.localStorage.cart_unique_id;
  },
  getCompareListId(state) {
    return state.localStorage.comparlist_unique_id;
  },
  getWishListId(state) {
    return state.localStorage.wishlist_unique_id?.value;
  },
};

export const mutations = {
  SET_LOCAL_VAR(state, payload) {
    state.localStorage[payload.var] = payload.val;
  },
};

export const actions = {
  resetCart({ commit }) {
    commit("cart/RESET_CART");
    commit("SET_LOCAL_VAR", {
      var: "cart_unique_id",
      val: null,
    });
  },
  resetWishList({ commit }) {
    commit("wishlist/RESET_WISHLIST");
    localStorage.setItem("conf-m8ht77-wishlist", JSON.stringify([]));
    commit("SET_LOCAL_VAR", {
      var: "wishlist_unique_id",
      val: null,
    });
  },
  resetCompareList({ commit }) {
    commit("comparison/RESET_COMPARELIST");
    commit("SET_LOCAL_VAR", {
      var: "comparlist_unique_id",
      val: null,
    });
    localStorage.setItem("conf-m8ht77-compare", JSON.stringify([]));
  },
  async getCart({ commit, state, dispatch, getters }, route) {
    try {
      let cartId = getters.getCartId;

      let getCartByCartID = false; // TODO refactor it
      const cartUniqueIdRoutes = ["cart"];
      if (
        route &&
        cartUniqueIdRoutes.some((path) =>
          route.path.split("/").includes(path)
        ) &&
        route.params.id &&
        route.params.id !== cartId
      ) {
        cartId = route.params.id;
        getCartByCartID = true;
      }

      // Build affiliate params from route query
      const affiliateParams = route?.query ? buildAffiliateParams(route.query) : undefined;
      const additionalParams = affiliateParams
        ? { affiliate_params: JSON.stringify(affiliateParams) }
        : undefined;

      const userInfo = getters["auth/getUserInfo"];
      const { data } = await this.$api.cart.getCart({
        cartId,
        userInfo,
        getCartByCartID,
        additionalParams,
      });
      commit("SET_LOCAL_VAR", {
        var: "cart_unique_id",
        val: data.data.unique_id,
      });
      commit("cart/SET_CART_INFO", data.data);
    } catch (err) {
      console.error("err");
      return Promise.reject(err);
    }
  },
  setItemWithExpiration({ commit }, { key, value, ttl }) {
    // ttl is in milliseconds
    const now = new Date().getTime();
    const item = {
      value,
      expiry: now + ttl,
    };
    commit("SET_LOCAL_VAR", {
      var: key,
      val: item,
    });
  },
  getItemWithExpiration({ commit, state }, key) {
    const item = state.localStorage[key];
    // If the item doesn't exist, return null
    if (!item || !item?.expiry) {
      return null;
    }
    const now = new Date().getTime();
    // Compare the expiry time of the item with the current time
    if (now > item.expiry) {
      return null;
    }
    return item;
  },
  updateWishlistId({ dispatch }, unique_id) {
    dispatch("setItemWithExpiration", {
      key: "wishlist_unique_id",
      value: unique_id,
      ttl: 1000 * 60 * 60 * 24 * 7, // 7 days
    });
  },
  async getWishList({ commit, getters, dispatch }) {
    const value = await dispatch("getItemWithExpiration", "wishlist_unique_id");
    if (!value) {
      dispatch("resetWishList");
    }
    try {
      const wishListId = getters.getWishListId;
      const userInfo = getters["auth/getUserInfo"];
      const { data } = await this.$api.wishlist.getWishList({
        wishListId,
        userInfo,
      });
      if (!value) {
        await dispatch("updateWishlistId", data.data.unique_id);
      }

      commit("wishlist/SET_WISHLIST", data.data.baggage);
      const localStorageData =
        data?.data?.baggage?.map((el) => ({
          engraving: Array.isArray(el.engraving) ? {} : el.engraving,
          sku: el.sku,
        })) || [];
      localStorage.setItem(
        "conf-m8ht77-wishlist",
        JSON.stringify(localStorageData)
      );
      commit("wishlist/SET_WISHLIST_STATUS", true);
    } catch (err) {
      console.error("err");
      console.log("err - ", err);
    }
  },
  async getCompareList({ commit, getters }) {
    try {
      const compareListId = getters.getCompareListId;
      const userInfo = getters["auth/getUserInfo"];
      // console.log("wishListId - ", wishListId);
      const { data } = await this.$api.comparison.getCompareList({
        compareListId,
        userInfo,
      });
      commit("SET_LOCAL_VAR", {
        var: "comparlist_unique_id",
        val: data.data.unique_id,
      });
      commit("comparison/SET_COMPARE_LIST", data.data.baggage);
      const localStorageData =
        data?.data?.baggage?.map((el) => ({
          engraving: el.engraving,
          sku: el.sku,
        })) || [];
      localStorage.setItem(
        "conf-m8ht77-compare",
        JSON.stringify(localStorageData)
      );
    } catch (err) {
      console.error("err");
      console.log("err - ", err);
    }
  },
  nuxtServerInit({ dispatch, commit }, { $cookies }) {
    // await dispatch("general/getSiteSettings"); moved to plugins
    // const userInfo = $cookies.get(COOKIE_KEYS.accessToken);
    // if (userInfo) {
    //   dispatch("auth/setUserInfo", userInfo);
    // }
  },
  nuxtClientInit({ dispatch, getters, state }, route) {
    // try {
    //   await dispatch("getCart");
    //   const cartId = getters.getCartId;
    //   await dispatch("orders/getShippingMethods", { cart_unique_id: cartId });
    // } catch (err) {
    //   console.log("err - ", err);
    // }
    async function getCartPromise() {
      try {
        await dispatch("getCart", route);
        const cartId = getters.getCartId;
        // await dispatch("orders/getShippingMethods", { cart_unique_id: cartId });
        return Promise.resolve();
      } catch (err) {
        console.error("err - ", err);
        return Promise.reject(err);
      }
    }
    const promises = [
      dispatch("getWishList"),
      // dispatch("getCompareList"),
      getCartPromise(),
    ];
    Promise.allSettled(promises);
    if (!state.general.collectionList?.length) {
      setTimeout(() => {
        dispatch("general/fetchCollectionList");
      }, 4000);
    }

    // await dispatch("getCart");
    // await dispatch("getWishList");
    // await dispatch("getCompareList");
    // const cartId = getters.getCartId;
    // await dispatch("orders/getShippingMethods", { cart_unique_id: cartId });
  },
};
